import { useCollectionData } from "react-firebase-hooks/firestore";
import { collection, doc, query } from "firebase/firestore";
import { db } from "@poseidon/firebase";
import { where } from "firebase/firestore";
import { withIdConverter } from "@poseidon/firebase/converters/with-id";

export function useSailorApplications(sailorId) {
  const [sailorApplications, loading, error] = useCollectionData(
    query(
      collection(db, "applications"),
      where("applicants", "array-contains", doc(db, "sailors", sailorId))
    ).withConverter(withIdConverter)
  );
  return { sailorApplications, loading, error };
}
